export default function SearchNavbarIcon({ className = "", onClick = null }) {
  return (
    <>
      <svg
        className={className}
        onClick={onClick}
        id="Capa_2"
        data-name="Capa 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 700 700"
      >
        <path
          d="M600.85,544.02l-100.03-100.03c26.06-37.37,39.8-81.17,39.8-127.01,0-30.03-5.88-59.16-17.48-86.58-11.2-26.49-27.24-50.28-47.67-70.7-20.43-20.43-44.21-36.46-70.7-47.67-27.43-11.6-56.56-17.48-86.58-17.48s-59.16,5.88-86.58,17.48c-26.49,11.2-50.28,27.24-70.7,47.67s-36.46,44.21-47.67,70.7c-11.6,27.43-17.48,56.56-17.48,86.58s5.88,59.16,17.48,86.58c11.2,26.49,27.24,50.28,47.67,70.7s44.21,36.46,70.7,47.67c27.43,11.6,56.56,17.48,86.58,17.48,44.6,0,87.42-13.07,124.17-37.85l100.47,100.48c2.19,2.19,5.11,3.4,8.21,3.4s6.02-1.21,8.21-3.4l41.61-41.61c4.53-4.53,4.53-11.89,0-16.42ZM458.08,316.99c0,37.37-14.55,72.5-40.97,98.92s-61.55,40.97-98.92,40.97-72.5-14.55-98.92-40.97c-26.42-26.42-40.97-61.55-40.97-98.92s14.55-72.5,40.97-98.92c26.42-26.42,61.55-40.97,98.92-40.97s72.5,14.55,98.92,40.97,40.97,61.55,40.97,98.92Z"
          style={{ strokeWidth: "0px" }}
        />
      </svg>
    </>
  );
}
